






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class BorderBox extends Vue {
  @Prop()
  spaceBetween?: boolean;
}
